import * as firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";

const apiKey = process.env.FIREBASE_TOKEN;
const firebaseConfig = process.env.FIREBASE_CONFIG || {
  apiKey,
  authDomain: "local-e-consumer.firebaseapp.com",
  databaseURL: "https://local-e-consumer.firebaseio.com",
  projectId: "local-e-consumer",
  storageBucket: "local-e-consumer.appspot.com",
  messagingSenderId: "1023078271921",
  appId: "1:1023078271921:web:67449cd458f4f6d73b8b90"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

export const setUserFbLogin = async token => {
  return await firebase
    .auth()
    .signInWithCustomToken(token)
    .catch(function(error) {
      console.log(error);
    });
};
export default app;
